const DefaultLanguage = () => {
    const defaultLanguage = 'en'

    if (localStorage.getItem('general_setting')) {
        const language = JSON.parse(localStorage.getItem('general_setting')).language
        if (language !== defaultLanguage) {
            return language
        } else {
            return defaultLanguage
        }
    } else {
        return defaultLanguage
    }
}

export default DefaultLanguage
